<template>
	<div class="root">
		<vipMeetingHeader/>
		<div class="container">
			<TopBar style='padding: 0 10px;margin-bottom:20px;'/>
			<div class="info">
				<div class="appointment-info">
					<h3>预约信息<span v-if='storeName'>-{{storeName}}</span></h3>
					<div class="titles">
						<div class="item room-name"></div>
						<div class="item date">日期</div>
						<div class="item timerange">预约时段</div>
						<div class="item money">{{PriceType?'点数':'金额'}}</div>
						<div class="item other">其他</div>
					</div>
					<div class="appointment-item" v-for='item in cart'>
						<div class="item room-name">{{item.RoomName || item.ProductName}}</div>
						<div class="item date">{{item.BookingDate}}</div>
						<div class="item timerange"><span v-if='item.BeginTime'>{{item.BeginTime}} - {{item.EndTime}}</span></div>
						<div class="item money">{{item.PriceType==1?'':'￥'}}{{item.Amount}}</div>
						<div class="item other"></div>
					</div>
					<div class="additional" v-for='item in others'>
						<div class="name">
							<div>{{item.Name}}</div>
							<div class="desc">{{item.Description}}</div>
						</div>
						<div class="money">{{item.PriceType==1?'点数':'￥'}}{{item.Price}}</div>
						<div class="money" v-if="item.PriceType==1">{{Point}}</div>
						<div class="buy-tool">
							<div @click='modifyOther(item,-1)' class='tool-btn' type='text'><Icon type="md-remove" /></div>
							<div class="number">{{item.num||0}}</div>
							<div @click='modifyOther(item,1)' class='tool-btn' type='text'><Icon type="md-add" /></div>
						</div>
					</div>
				</div>
				<div class="price-info">
					<div class="total">
						<h4>应付总{{PriceType?'点数':'金额'}}：</h4>
						<div class="price">{{PriceType?'':'￥'}}{{amount}}</div>
					</div>
					<div class="total" v-if="PriceType">
						<h4>点数余额：</h4>
						<div class="price">{{Point}}</div>
					</div>
					<div class="tips">
						<p style="margin-top: 10px;"><span style="color:#B176C5;">限时取消：</span>截止预约日期前一天，可自主免费取消预约；超时限后不再接受取消，如未出席仍视为占用。</p>
						<!-- <p style="margin-top: 10px;"><span style="color:#B176C5;">注意事项：</span>如取消，该笔预约订单内所有预约时间段将一并取消，不支持部分取消。</p> -->
						<p style="margin-top: 10px;"><span style="color:#B176C5;">收费方式：</span>{{ chargeMethod }}</p>
					</div>
				</div>
				<div class='buyer'>
					<h4>预约人</h4>
					<div class="name">
						<div class="label">姓名<span>*</span></div>
						<input placeholder="请填写联系人" class='input' :class='{error:error.name}' v-model='name' maxlength='80' @blur='checkName' />
						<p class="error" v-if='error.name'>{{error.name}}</p>
					</div>
					<div class="phone">
						<div class="label">联系方式<span>*</span></div>
						<input placeholder="请填写联系电话" class='input' :class='{error:error.phone}' v-model='phone' @blur='checkPhone' />
						<p class="error" v-if='error.phone'>{{error.phone}}</p>
					</div>
					<!-- <div class="remark">
						<div class="label">房间准备要求</div>
						<Input :autosize='{minRows: 4}' maxlength='300' type='textarea' placeholder="如:布置会议室安排投影仪等" v-model='remark' />
					</div> -->
				</div>
			</div>
			<div class="bottom">
				<Button @click='goConfirm' size='large' class='pay-btn' type='primary'>确认预约</Button>
			</div>
		</div>
		<Modal v-model="modal" title="当前用户非VIpBiz，请填写代缴账户" >
			<div slot="footer">
				<Button type="ghost" style="color: black;" @click="modal = false">取消</Button>
				<Button type="primary" @click="provingVip('formInline')">确定</Button>
			</div>
			<Form ref="formInline" :model="formInline" :rules="ruleInline"  :label-width="80">
				<FormItem label="代缴账户" prop="VipNo">
					<Input type="text" v-model="formInline.VipNo" placeholder="请填写代缴账户" />
				</FormItem>
			</Form>
		</Modal>
		<Modal class="rule" class-name="vertical-center-modal" v-model="modalRule" width="800" :closable="false" :mask-closable="false">
			<template #header>
                <p class="rule_title">
                    <span>{{ rule.title }}</span>
                </p>
            </template>
			<div class="rule_text">
                <p v-for="(text,i) in rule.text" :key="i">{{ text }}</p>
				<p class="bottomText">多特瑞中国</p>
            </div>
            <template #footer>
                <Button type="primary" size="large" long @click="modalRule = false">已知晓</Button>
            </template>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import vipMeetingHeader from '@/components/header/vipMeetingHeader'
	import TopBar from '@/components/common/TopBar'
	import {RE_PHONE} from '@/components/common/regex'
	export default {
		data() {
			return {
				phone:'',
				name:'',
				remark:'',
				error:{
					phone:'',
					name:'',
				},
				storeName:'',
				cart:[],
				others:[],
				loading:false,
				modal:false,
				modalRule:true,
                formInline: {
                    VipNo: '',
                },
                ruleInline: {
					VipNo: [
                        { required: true, message: '请填写代缴账户', trigger: 'blur' }
                    ],
                },
				PriceType:false,
				Point:null,
				rule:{
					title:'VIP室使用规范',
					text:[
						'1. VIP内禁止举办带有收费性质的课程或沙龙；',
						'2. 保持室内环境，请勿携带气味强烈的食品、饮料等在会议室内食用；',
						'3. 爱护室内设备设施，若发生设备损坏或遗失，需按设备价格由会议负责人进行赔偿；',
						'4. VIP室内使用时间请按照申请时段举行，适当提醒切勿超时，以免影响后续使用；',
						'5. VIP室仅供顾客聊天、产品分享、产品体验等与精油相关事宜，禁止脱衣及大面积裸露皮肤的芳香调理。',
					]
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			phone(){
				this.error.phone = ''
			},
			name(){
				this.error.name = ''
			}
		},
		mixins:[],
		components: {
			vipMeetingHeader,
			TopBar
		},
		computed: {
			...mapState({
				userInfo:state=>state.common.userInfo,
				wechatUserInfo: state => state.common.wechatUserInfo.value.binding
,
			}),
			amount(){
				let sum = 0
				sum = this.cart.reduce((prev,cur)=>{
					return prev + cur.Amount
				},sum)
				sum = this.others.reduce((prev,cur)=>{
					return prev + cur.Price * (cur.num || 0)
				},sum)
				return sum
			},
			chargeMethod(){
				if(this.amount <= 0){
					return '不扣费，直接提交预约订单即可。'
				}
				return '预约时即扣除5个回馈点数，如不足则无法预约成功。'
			},
		},
		methods: {
			...mapActions([
				'getVIPReservationCartAction',
				'getVIPReservationDetailAction',
				'postVIPReservationAdditionalAction',
				'getVIPReservationOrdersAction',
				'postVIPDeterminePaymentuserAction',
				'getVIPMeetingPointAction',
			]),
			async initData(){
				let response2 = await this.getVIPReservationOrdersAction({
					BookingId:this.$route.query?.code
				})
				this.phone = this.userInfo?.MobilePhone
				this.name = this.userInfo?.Name
				let orderStatus = response2[0]?.OrderStatus
				if (orderStatus == 'Pay') {
					this.$router.replace('/vipmeeting/orders')
					return
				}
				let LifeVIP_019 = await this.getVIPMeetingPointAction()
				this.Point = LifeVIP_019
				let response1 = await this.getVIPReservationDetailAction({
					BookingId:this.$route.query?.code
				})
				this.cart = response1
				this.storeName = response1[0]?.StoreName
				this.PriceType = response1[0]?.PriceType==1 ? true : false
				
				let response = await this.getVIPReservationCartAction({
					BookingId:this.$route.query?.code
				})
				this.others = response
			},
			checkPhone(){
				this.error.phone = ''
				if (!this.phone) {
					this.error.phone = '请填写联系电话'
					return false
				}
				if (!RE_PHONE.test(this.phone)) {
					this.error.phone = '请填写正确的手机号码'
					return false	
				}
				return true
			},
			checkName(){
				this.error.name = ''
				if (!this.name) {
					this.error.name = '请填写联系人'
					return false
				}
				return true
			},
			modifyOther(item,factor) {
				if (!item.num && factor == 1) {
					item.num = 1;
				} else {
					if(item.num) item.num += factor
				}
				
				this.others = [...this.others]
			},
		     provingVip(name){
                this.$refs[name].validate(async (valid) => {
                    if (valid) {
						let response = await this.postVIPDeterminePaymentuserAction({VipNo:this.formInline.VipNo})
						if (response.isVIPBiz == 1) {
							this.$Message.success('验证成功');
							this.reservationAdditional()
							this.modal = false
						} 
						if(response.isVIPBiz == 0){
							this.$Message.info('该账号不得作为服务费代扣账号，请重新填写。');
						}
						if (response.isVIPBiz == -1) {
							this.$Message.error('未找到该用户,请确定用户存在后再次填写。');
						}
						if (response.isVIPBiz == 2) {
							this.$Message.error('该用户已中止，请重新填写。');
						}

                    }
                })
			},
			goConfirm(){
				if(this.amount > 0 && this.PriceType){
					this.$Modal.confirm({
						title: '支付确认',
						content: '您需支付'+this.amount+'个点数',
						loading: true,
						onOk: () => {
							setTimeout(() => {
								this.$Modal.remove();
								this.goPay()
							}, 500);
						},
					});
				}else{
					this.goPay()
				}
			},
			goPay(){
				let valid1 = this.checkPhone() 
				let valid2 = this.checkName()
				if (!valid1 || !valid2) return 
				// if(this.wechatUserInfo.customer_type !='VIpBiz'){
				// 	this.formInline.VipNo=''
				// 	this.modal=true
				// }else{
					this.reservationAdditional()
				// }
			},
			async reservationAdditional(){
					if (this.loading) return
				    // let valid1 = this.checkPhone() 
				    // let valid2 = this.checkName()
				    // if (!valid1 || !valid2) return
					
				    this.loading = true
				    let params = {
				        BookingId:this.$route.query?.code,
					    OrderStatus:'Pay',
					    Amount:this.amount,
					    TotalPaid:0,
					    Discount:0,
					    BookUserName:this.name,
					    MobilePhone:this.phone,
					    Description:this.remark,
						WithholdAccount:this.formInline.VipNo,
					    Rooms:this.others.filter(item=>item.num).map(item=>{
						    return {
							    IsRoom:0,
							    RoomId:item.RoomId,
							    ProductId:item.ID,
							    Price:item.Price,
							    Qty:item.num,
							    Amount:item.Price * item.num,
							    Discount:0,
							    BookingDate:this.cart[0].BookingDate,
							    TimeRangeId:0,
						    }
					}),
				}
				let response = await this.postVIPReservationAdditionalAction(params)
				this.loading = false
				if (response?.Value == 1) {
					let content = '恭喜您，预约成功！期待您准时香约！'
					if(this.PriceType){
						// 点数
						this.$router.push(`/vipmeeting/payresult?code=${this.$route.query?.code}`)
						this.$Message.success(content);
					}else{
						setTimeout(() => {
							// 金额
							this.$Modal.success({
								title:'预约成功',
								content:content,
								onOk:()=>{
									this.$router.push('/vipmeeting/orders')
								}
							})
						}, 500);
					}
				} else if (typeof response?.Value == "string") {
					setTimeout(() => {
						this.$Modal.error({
							title:'提示',
							content:response?.Value,
						})
					}, 500);
				}				
			}
			
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.error {
		color:red;
	}
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.info {
		padding: 20px;
		background-color: white;
		border-radius: 20px;
		h3 {
			@include fontSize($font-size-30);
			font-weight: normal;
			margin-bottom: 20px;
			border-bottom: 1px dashed #aaa;
		}
		.appointment-info {
			border-bottom: 1px dashed #aaa;
			@include fontSize($font-size-16);
			.titles {
				display:flex;
				margin-bottom: 10px;
				max-width:1000px;
				.item {
					flex:1;
					text-align: center;
				}
			}
			.appointment-item {
				margin-bottom: 10px;
				display:flex;
				max-width:1000px;
				.item {
					flex:1;
					text-align: center;
				}
				.room-name {
					text-align: left;
					margin-bottom: 10px;
				}
				.timerange {
					color:$theme-color;
				}
				.money {
					color:red;
				}
			}
			.additional {
				display:flex;
				align-items: center;
				max-width:1000px;
				margin-top: 0;
				justify-content: space-between;
				margin-bottom: 10px;
				.name {
					flex: 3;
					color:$theme-color;
					.desc {
						font-size: 13px;
						color:#999;
						margin-top: 3px;
					}
				}
				.money {
					flex:1;
					color:red;
					text-align:center;
				}
				.buy-tool {
					flex:1;
					display:flex;
					align-items: center;
					justify-content: center;
					.number {
						box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
						text-align: center;
						width:40px;
						height:40px;
						display:flex;
						align-items: center;
						justify-content: center;
						margin:0 10px;
						border-radius: 20px;
						color:$theme-color;
						font-weight: bold;
						@include fontSize($font-size-20);
					}
					.tool-btn {
						cursor: pointer;
						display:flex;
						align-items: center;
						justify-content: center;
						width:30px;
						height:30px;
						border:1px solid $theme-color;
						color:$theme-color;
						font-size: 20px;
					}
				}
			}
		}
		.price-info {
			padding-top: 20px;
			.price-item {
				display:flex;
				justify-content: space-between;
				@include fontSize($font-size-16);
				margin-bottom: 10px;
				.price {
					font-weight: bold;
				}
			}
			.total {
				display:flex;
				align-items: center;
				// margin-top: 20px;
				h4 {
					@include fontSize($font-size-20);
					margin-bottom: 0;
				}
				.price {
					font-weight: bold;
					color:red;
					@include fontSize($font-size-22);
				}
			}
			.tips {
				margin-top: 10px;
			}
		}
		.buyer {
			border-top: 1px dashed #aaa;
			margin-top: 20px;
			padding-top: 10px;
			h4 {
				@include fontSize($font-size-20);
			}
			.name,.phone,.remark {
				margin-top: 20px;
				.label {
					@include fontSize($font-size-16);
					margin-bottom: 10px;
					display:flex;
					align-items: center;
					.checkbox {
						margin-left: 20px;
					}
					span {
						color:red;
					}
				}
				.input {
					border:none;
					outline:none;
					color:$theme-color;
					width:200px;
					@include fontSize($font-size-16);
					border-bottom: 1px solid $theme-color;
				}
				input.error {
					border-bottom: 1px solid red;
				}
			}
		}
	}
	.bottom {
		text-align: center;
		.pay-btn {
			margin:30px 0;
			height:44px;
			width:360px;
			border-radius: 30px;
		}
	}
	.rule{
		.rule_title{
			text-align: center;
			font-size: 22px;
			color: #515a6e;
		}
		.rule_text{
			line-height: 40px;
			font-size: 16px;
			.bottomText{
				text-align: right;
				padding-top: 30px;
			}
		}
	}
	@media (max-width: 768px){
		.container {
			padding-top: 2.4rem;
		}
		.rule{
			.rule_title{
				text-align: center;
				font-size: 20px;
				color: #515a6e;
			}
			.rule_text{
				line-height: 38px;
				font-size: 14px;
			}
		}
	}
</style>
<style lang="scss">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;
		.ivu-modal{
			top: 0;
		}
    }
</style>